import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { Base } from './Base.js';
import * as utils from './utils.js';
export var Struct = /*#__PURE__*/function (_Base) {
  _inherits(Struct, _Base);
  var _super = _createSuper(Struct);
  function Struct() {
    var _this;
    var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Struct);
    _this = _super.call(this);
    _this.fields = fields;
    return _this;
  }
  _createClass(Struct, [{
    key: "decode",
    value: function decode(stream, parent) {
      var length = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var res = this._setup(stream, parent, length);
      this._parseFields(stream, res, this.fields);
      if (this.process != null) {
        this.process.call(res, stream);
      }
      return res;
    }
  }, {
    key: "_setup",
    value: function _setup(stream, parent, length) {
      var res = {};

      // define hidden properties
      Object.defineProperties(res, {
        parent: {
          value: parent
        },
        _startOffset: {
          value: stream.pos
        },
        _currentOffset: {
          value: 0,
          writable: true
        },
        _length: {
          value: length
        }
      });
      return res;
    }
  }, {
    key: "_parseFields",
    value: function _parseFields(stream, res, fields) {
      for (var key in fields) {
        var val;
        var type = fields[key];
        if (typeof type === 'function') {
          val = type.call(res, res);
        } else {
          val = type.decode(stream, res);
        }
        if (val !== undefined) {
          if (val instanceof utils.PropertyDescriptor) {
            Object.defineProperty(res, key, val);
          } else {
            res[key] = val;
          }
        }
        res._currentOffset = stream.pos - res._startOffset;
      }
    }
  }, {
    key: "size",
    value: function size(val, parent) {
      var includePointers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      if (val == null) {
        val = {};
      }
      var ctx = {
        parent: parent,
        val: val,
        pointerSize: 0
      };
      if (this.preEncode != null) {
        this.preEncode.call(val);
      }
      var size = 0;
      for (var key in this.fields) {
        var type = this.fields[key];
        if (type.size != null) {
          size += type.size(val[key], ctx);
        }
      }
      if (includePointers) {
        size += ctx.pointerSize;
      }
      return size;
    }
  }, {
    key: "encode",
    value: function encode(stream, val, parent) {
      var type;
      if (this.preEncode != null) {
        this.preEncode.call(val, stream);
      }
      var ctx = {
        pointers: [],
        startOffset: stream.pos,
        parent: parent,
        val: val,
        pointerSize: 0
      };
      ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
      for (var key in this.fields) {
        type = this.fields[key];
        if (type.encode != null) {
          type.encode(stream, val[key], ctx);
        }
      }
      var i = 0;
      while (i < ctx.pointers.length) {
        var ptr = ctx.pointers[i++];
        ptr.type.encode(stream, ptr.val, ptr.parent);
      }
    }
  }]);
  return Struct;
}(Base);